import { render, staticRenderFns } from "./releaseNews.vue?vue&type=template&id=cfba628e&scoped=true&"
import script from "./releaseNews.vue?vue&type=script&lang=js&"
export * from "./releaseNews.vue?vue&type=script&lang=js&"
import style0 from "./releaseNews.vue?vue&type=style&index=0&id=cfba628e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfba628e",
  null
  
)

export default component.exports